import { c as _c } from "react/compiler-runtime";
import { useCallback, useSyncExternalStore } from 'react';

/**
 * Hook to detect if the current screen width is mobile (< 768px)
 * Returns true for mobile screen sizes, false for larger screens
 */
export function useIsMobileScreen(t0) {
  const $ = _c(2);
  const breakpoint = t0 === undefined ? 768 : t0;
  let t1;
  if ($[0] !== breakpoint) {
    t1 = () => window.innerWidth < breakpoint;
    $[0] = breakpoint;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useSyncExternalStore(subscribeToResize, t1, _temp);
}

/** Notifies 150ms after the last resize, so a drag-resize re-renders once. */
function _temp() {
  return false;
}
function subscribeToResize(onChange: () => void) {
  let timeoutId: NodeJS.Timeout | undefined;
  const onResize = () => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(onChange, 150);
  };
  window.addEventListener('resize', onResize);
  return () => {
    clearTimeout(timeoutId);
    window.removeEventListener('resize', onResize);
  };
}